//
//
//
//
//
//
//
//
//
export default {
  name: 'CategoryProductListLoading'
};